import { render } from "./DynamicRoute.vue?vue&type=template&id=69cf2932"
import script from "./DynamicRoute.vue?vue&type=script&lang=js"
export * from "./DynamicRoute.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__